import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-forgot-password-mbl',
  templateUrl: './forgot-password-mbl.component.html',
  styleUrls: ['./forgot-password-mbl.component.css']
})
export class ForgotPasswordMblComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
